import BaseModelAPI from '../BaseModelAPI';

export default class PickingForDeliveryList extends BaseModelAPI {

	static entity = 'pickingfordeliverylist'
	static entityName = 'pickingfordelivery';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
